
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ExternalLink, Share2 } from 'lucide-react';
import { toast } from 'sonner';

const UlosottoSummarySection: React.FC = () => {
  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Ulosoton ABC - Kaikki mitä sinun tulee tietää ulosotosta',
        text: 'Hyödyllinen tietopaketti ulosotosta ja miten sen kanssa selviää',
        url: window.location.href,
      })
      .then(() => console.log('Shared successfully'))
      .catch((error) => console.log('Error sharing:', error));
    } else {
      // Fallback for browsers that don't support the Web Share API
      navigator.clipboard.writeText(window.location.href)
        .then(() => toast.success('Linkki kopioitu leikepöydälle'))
        .catch(() => toast.error('Linkin kopiointi epäonnistui'));
    }
  };

  return (
    <section className="mt-12 mb-6">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Yhteenveto</h2>
      <p className="mb-6 text-gray-700">
        Ulosotto on vakava asia, mutta sen kanssa voi oppia elämään ja siitä voi selviytyä. Avoimuus, rehellisyys ja 
        aktiivinen yhteydenpito viranomaisiin auttavat tilanteen hallinnassa. Muista, että apua on saatavilla - 
        talous- ja velkaneuvonnasta saat maksutonta tukea ja neuvontaa.
      </p>

      <div className="bg-blue-100 p-6 rounded-lg my-8">
        <h3 className="text-xl font-semibold mb-4 text-blue-800">Tarvitsetko apua velkatilanteesi selvittämisessä?</h3>
        <p className="mb-4 text-gray-700">
          Jos olet jo ulosotossa tai pelkäät joutuvasi siihen, voit selvittää vaihtoehtojasi esimerkiksi 
          yhdistelylainan avulla. Säästät parhaimmillaan satoja euroja kuukaudessa!
        </p>
        <div className="flex flex-wrap gap-4">
          <Link to="/kilpailuta">
            <Button className="bg-blue-700 hover:bg-blue-800">
              Kilpailuta lainatarjoukset maksutta
            </Button>
          </Link>
          
          <Button 
            variant="outline" 
            className="flex items-center gap-2 border-blue-300"
            onClick={handleShare}
          >
            <Share2 size={16} />
            Jaa artikkeli
          </Button>
        </div>
      </div>
      
      <div className="mt-8 p-4 bg-gray-50 rounded border border-gray-200">
        <h4 className="font-medium text-gray-700 mb-2">Lähteet ja lisätietoa:</h4>
        <ul className="space-y-2 text-sm text-gray-600">
          <li>
            <a 
              href="https://oikeus.fi/ulosotto/fi/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center hover:underline text-blue-600"
            >
              Oikeus.fi: Ulosotto <ExternalLink size={14} className="ml-1" />
            </a>
          </li>
          <li>
            <a 
              href="https://www.takuusaatio.fi/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center hover:underline text-blue-600"
            >
              Takuusäätiö <ExternalLink size={14} className="ml-1" />
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default UlosottoSummarySection;
